import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { APP_NAME } from 'app-config'

import { getAppConfigAction } from 'root-redux/actions/common'
import { TAppDispatch } from 'root-redux/store/store'

import {
  InitialPageRequest,
  measureInitialPageRequest,
} from 'helpers/initialPagePerformance'

export const useInitAppConfig = (): void => {
  const dispatch: TAppDispatch = useDispatch()

  useEffect(() => {
    if (!APP_NAME) return

    measureInitialPageRequest({
      name: InitialPageRequest.CONFIG,
      resourcePath: `/v1/flow/${APP_NAME}/config`,
      request: () => dispatch(getAppConfigAction()),
    })
  }, [dispatch])
}
